import React from 'react';

import water0 from '../assets/waterLevels/0water.png';
import water3to10 from '../assets/waterLevels/3-10water.png';
import water10to20 from '../assets/waterLevels/10-20water.png';
import water20to30 from '../assets/waterLevels/20-30water.png';
import water30to40 from '../assets/waterLevels/30-40water.png';
import water40to50 from '../assets/waterLevels/40-50water.png';
import water50to60 from '../assets/waterLevels/50-60water.png';
import water60to70 from '../assets/waterLevels/60-70water.png';
import water70to80 from '../assets/waterLevels/70-80water.png';
import water80to90 from '../assets/waterLevels/80-90water.png';
import water90to100 from '../assets/waterLevels/90-100water.png';
import waterNone from '../assets/waterLevels/NoneWater.png';

const waterLevels = [
  { max: 3, img: water0 },
  { max: 10, img: water3to10 },
  { max: 20, img: water10to20 },
  { max: 30, img: water20to30 },
  { max: 40, img: water30to40 },
  { max: 50, img: water40to50 },
  { max: 60, img: water50to60 },
  { max: 70, img: water60to70 },
  { max: 80, img: water70to80 },
  { max: 90, img: water80to90 },
  { max: 100, img: water90to100 }
];

function WaterLevelIndicator({ waterLevel }) {
  const getImageForWaterLevel = (level) => {
    if (level === -1) {
      return waterNone;
    }
    return waterLevels.find(water => level <= water.max)?.img;
  };

  return <img src={getImageForWaterLevel(waterLevel)} alt="Water level indicator" />;
}

export default WaterLevelIndicator;